import { CLIENT_ID } from '../config/Config'
import React, { useState, useEffect, useRef } from "react" ;
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import './PayPageStyle.css';
import { useNavigate } from "react-router-dom";



const PayPage = ({tag}) => {
    const [show, setShow] = useState(false);
    const [success, setSuccess] = useState(false);
    const [ErrorMessage, setErrorMessage] = useState("");
    const [orderID, setOrderID] = useState(false);
    const navigate = useNavigate();
    const endOfSide = useRef(null);

    // Weiterer Code hier
    //console.log('Tag is now a string:', tag);

    const changeAccountState = async (tag) => {
        try {
          const response = await fetch('https://ff-schwebda.de/JuniorAlarm/V2/Server/ChangeAccountState.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              tag,
            }),
          });
    
          if (response.ok) {
            const data = await response.json();
            //console.log(data['message'])
            // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
            console.log('Erfolgreich gesendet');
            navigate("/MainPage")
          } else {
            //const data = await response.json();
            //console.log(data);
            console.error('Fehler Response:', response.statusText);
          }
        } catch (error) {
          console.error('Fehler beim senden:', error);
        }
    };

    

    // Funktion zum Scrollen ans Ende der Seite
    const scrollToBottom = () => {
        endOfSide.current?.lastElementChild?.scrollIntoView()
    };

    const handleCheckboxChange = (event) => {
        setShow(event.target.checked);
        scrollToBottom();
    };

    // creates a paypal order
    const createOrder = (data, actions) => {
        return actions.order.create({
            purchase_units: [
                {
                    description: "Junior Alarm Monatsabo",
                    amount: {
                        currency_code: "EUR",
                        value: 20.00,
                    },
                },
            ],
        }).then((orderID) => {
                setOrderID(orderID);
                return orderID;
            });
    };

    // check Approval
    const onApprove = (data, actions) => {
        return actions.order.capture().then(function (details) {
            const { payer } = details;
            setSuccess(true);
            //console.log('Tag is now a string:', tag);
            changeAccountState(tag)
        });
    };

    //capture likely error
    const onError = (data, actions) => {
        setErrorMessage("An Error occured with your payment ");
    };

    useEffect(() => {
        if (success) {
            //alert("Payment successful!!");
            console.log('Order successful . Your order id is--', orderID);
        }
    },[success]);

    return (
        <div className='container'>
            <div className="titleContainer">
                <h2>Junior Alarm Monatsabo</h2>
            </div>
            <PayPalScriptProvider options={{ "client-id": CLIENT_ID , "currency": 'EUR'}}>
            <div className="product-img">
                <img
                    src="https://ff-schwebda.de/JuniorAlarm/V2/Images/App.jpg"
                    alt="JuniorAlarm App" />
                <img
                    src="https://ff-schwebda.de/JuniorAlarm/V2/Images/Web.png"
                    alt="JuniorAlarm Web" />
            </div>

            <div className="product-text">
                <h3>JuniorAlarm - Das smarte Alarmsystem für Jugendfeuerwehren</h3>
                <p>Mit dem <strong>JuniorAlarm Monatsabo</strong> bist du immer bereit für den Ernstfall. JuniorAlarm ist das erste Alarmsystem speziell entwickelt für die Junged im Ehrenamt und bietet ein umfassendes Toolset, um junge Leute sicher, schnell und effizient zu alarmieren.</p>

                <h3>Warum JuniorAlarm?</h3>
                <div class="listContainer">
                    <ul class="feature-list">
                    <li><strong>Schnelle und einfache Alarmierung:</strong> Mit einem Klick alle Mitglieder erreichen – direkt auf ihre Smartphones.</li>
                    <li><strong>Kritische Hinweise:</strong> Die Meldung erfolgt auch wenn das Smartphone lautlos ist</li>
                    <li><strong>Intuitive Bedienung:</strong> Einfache Handhabung, speziell abgestimmt auf die Bedürfnisse von Jugendleitern und -betreuern.</li>
                    <li><strong>Individuelle Anpassung:</strong> Erstelle personalisierte Alarme.</li>
                    <li><strong>Sichere Kommunikation:</strong> Verschlüsselte Nachrichten und direkte Rückmeldungen garantieren eine zuverlässige Kommunikation innerhalb des Teams.</li>
                    </ul>
                </div>

                <h3>Das bietet das Monatsabo:</h3>
                <div class="listContainer">
                    <ul class="feature-list">
                        <li><strong>Uneingeschränkter Zugriff:</strong> Nutze alle Funktionen von JuniorAlarm ohne Einschränkungen.</li>
                        <li><strong>Regelmäßige Updates:</strong> Profitiere von kontinuierlichen Verbesserungen und neuen Features.</li>
                        <li><strong>Priorisierter Support:</strong> Erhalte schnelle Hilfe bei Fragen und technischen Problemen.</li>
                    </ul>
                </div>
            </div>
                    
            <div>
                <p className="highlighted-price">20,00 €</p>
                <br></br>
            </div>        
                        
            <div className="checkbox-container">
                <input
                    type="checkbox"
                    id="accept-agbs"
                    checked={show}
                    onChange={handleCheckboxChange}
                />
                <label htmlFor="accept-agbs" className="checkbox-label">
                    Ich akzeptiere die <a href="https://mbsoftwaresolutions.de/produkte/apps/junioralarm/agb" target="_blank" rel="noopener noreferrer">AGBs</a>
                </label>
            </div>        
                    
                        
                <br></br>
                {show ? (
                    <PayPalButtons
                        ref={endOfSide}
                        style={{ layout: "vertical" }}
                        createOrder={createOrder}
                        onApprove={onApprove}
                    />
                ) : null}
        </PayPalScriptProvider>
        </div>
        
    );
};

export default PayPage;